const globals = {
    "app-application-name": "Application.name",
    "app-id-applicazione": "",
    "url-spa-mobile": process.env.REACT_APP_APP_URL_SPA_MOBILE,
    "app-nome-dominio": process.env.REACT_APP_APP_NOME_DOMINIO,
    "app-url-backend": process.env.REACT_APP_APP_URL_BACKEND,
    "app-url-backend-toponomastica": process.env.REACT_APP_APP_URL_BACKEND_TOPONOMASTICA,
    "app-url-backend-anagrafica": process.env.REACT_APP_APP_URL_BACKEND_ANAGRAFICA,
    "app-url-backend-apms": process.env.REACT_APP_APP_URL_BACKEND_APMS,
    "app-url-backend-sportelli": process.env.REACT_APP_APP_URL_BACKEND_SPORTELLI,
    "app-url-backend-assistenti": process.env.REACT_APP_APP_URL_BACKEND_ASSISTENTI,
    "app-url-backend-report": process.env.REACT_APP_APP_URL_BACKEND_REPORT,
    "errori-espliciti": process.env.REACT_APP_ERRORI_ESPLICITI,
    "app-url-dichiarazione-accessibilita": process.env.REACT_APP_APP_URL_DICHIARAZIONE_ACCESSIBILITA,
    "app-application-logo": "img/avatar/avatar_padre.png",
    "app-application-logo-woman": "img/avatar/avatar_madre.png",
    "app-application-logo-man": "img/avatar/avatar_padre.png",
    "app-application-logo-alt": "img/avatar/avatar_madre.png",
    "app-application-campana": "img/icons/campana.svg",
    "app-application-campana-notifiche": "img/icons/campana-notifiche.svg",
    "app-header-image": require("../img/logo/logo-regione-veneto--bw.png"),
    "app-icon-sprite": require("../svg/sprite.svg"),
    appWidthBreakdown: 1220,
    "lingua-default": "it-IT",
    lingua_default: "it"


};

export default globals;
